import { css, useTheme } from '@fable/theme'
import { FlexBox } from '@fable/components'

interface Props {
  loaded: boolean
  progress: number
  timer: string
}

export const AudioPlayerIndicator: React.VFC<Props> = ({
  loaded,
  progress,
  timer,
}) => {
  const { colors, motion } = useTheme()

  const styles = {
    playback: css`
      pointer-events: none;
    `,
    progress: css`
      width: 100%;
      height: 4px;
      background: ${colors.whiteSmoke};
      position: relative;
    `,
    indicator: css`
      height: 100%;
      background: ${colors.blackSwan};
      position: absolute;
      top: 0;
      left: 0;
    `,
    timer: css`
      margin-left: 11px;
      width: 30px;
      text-align: right;
      color: ${colors.hurricane};
      opacity: ${loaded ? 1 : 0};
      ${motion.transition('opacity')}
    `,
  }

  return (
    <FlexBox className={styles.playback} alignItems="center">
      <div className={styles.progress}>
        <span
          className={styles.indicator}
          style={{ width: `${progress}%` }}
        ></span>
      </div>
      <p className={styles.timer}>{timer}</p>
    </FlexBox>
  )
}
